import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';

const Booking = () => {
    const { slug } = useParams();

    return (
        <Box sx={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
            <iframe
                src={`/booking_stitch.html?slug=${slug}`}
                title="Hotel Booking"
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                }}
            />
        </Box>
    );
};

export default Booking;
